/* CLIENTS LIST DATA */
export const GET_CLIENTS_LIST = "GET_CLIENTS_LIST"
export const SET_CLIENTS_LIST = "SET_CLIENTS_LIST"
export const DELETE_CLIENT = "DELETE_CLIENT"

/* CLIENT DATA */
export const GET_CLIENT = "GET_CLIENT";
export const SET_CLIENT = "SET_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";

export const ADD_CLIENT = "ADD_CLIENT"

/* SHOW CLIENT LOADING */
export const SHOW_CLIENT_LOADER = "SHOW_CLIENT_LOADER";
export const HIDE_CLIENT_LOADER = "HIDER_CLIENT_LOADER";

export const SET_ERROR_CLIENT = "SET_ERROR_CLIENT";

/* LOADER */
export const SHOW_CLIENTS_LIST_LOADER = "SHOW_CLIENTS_LIST_LOADER"
export const HIDE_CLIENTS_LIST_LOADER = "HIDE_CLIENTS_LIST_LOADER"
